import type { ScreenFactory } from "../../taskScreenRegistry";

import { createOtherAssetsScreens } from "./other_assets";

export const otherAssetsTasks: Record<string, ScreenFactory> = {
  other_assets: createOtherAssetsScreens,
};
